import { ArrowRightIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';

export type RequestAccountHeroProps = {
  onRequestAccountClick: () => void;
  className?: string;
};

export const RequestAccountHero = ({
  onRequestAccountClick,
  className = '',
}: RequestAccountHeroProps) => {
  const { t } = useTranslation();

  return (
    <section
      className={`${className} h-auto lg:h-[682px] max-w-6xl m-auto mb-4 px-3 py-2 lg:px-10 pb-20 lg:pt-10 lg:pb-5 text-center lg:text-left relative bg-md-yellow rounded-3xl`}
    >
      <div className="md__request__account__hero__picture absolute bottom-0 left-0 right-0 top-0 bg-top bg-top lg:bg-right absolute z-10" />
      <div className="z-40 relative h-full">
        <h3 className="md__payments__container--h3">{t('RequestAccountHero.header')}</h3>
        <span className="text-xl text-md-blue pt-40 lg:pt-6">
          {t('RequestAccountHero.title')}{' '}
          <strong className="font-black">{t('RequestAccountHero.subtitle')}</strong>
        </span>
        <p className="text-base w-full lg:w-1/2 text-md-black font-normal font-secondary text-lg">
          <Trans components={{ bold: <strong className="font-bold" /> }}>
            RequestAccountHero.description
          </Trans>
        </p>
        <Button
          className="m-auto mt-10 lg:mx-0 py-2 lg:py-4 text-xs lg:text-sm w-[300px] rounded-full"
          variant="primary"
          size="free"
          type="button"
          title={t('RequestAccountHero.actionButton')}
          onClick={onRequestAccountClick}
          endIcon={<ArrowRightIcon className="h-5 w-5 text-white mr-6" aria-hidden="true" />}
        >
          {t('RequestAccountHero.actionButton')}
        </Button>
      </div>
    </section>
  );
};
